import { FC } from 'react';
import { Button, Icon } from 'learning-panel-components';
import { useNavigate } from 'react-router-dom';
import { translate } from 'translations';
import styles from './popup.module.scss';

const QuizPopup: FC<QuizPopupProps> = (props: QuizPopupProps) => {
    const { numOfAlowedMistakes, numberOfAttempts, isRetakeEnabled, onRetake } = props;
    const navigate = useNavigate();

    const onGoHome = () => {
        navigate('/app/home');
    };

    return (
        <div className={styles['background-wrapper']}>
            <div
                className={styles['pop-up-wrapper']}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/accountSettings.svg)` }}
            >
                <Icon name="close" className={styles.cancel} />
                <div className={styles['text-wrapper']}>
                    <div className={styles['main-text']}>{translate('WeSorry')}</div>
                    <div className={styles['sub-text']}>{translate('DidntPass')}</div>
                    <div className={styles['sub-text']}>{translate('YouMay')}</div>
                    {!isRetakeEnabled && <div className={styles.retake}>{translate('RetakeNotAllowed')}</div>}
                    <img alt="" src={`${process.env.PUBLIC_URL}/images/brokenNinja.svg`} className={styles.image} />
                </div>
                <div className={styles['test-details']}>{translate('TestDetails')}</div>
                <div className={styles['test-details-wrapper']}>
                    <div className={styles['attempts-wrapper']}>
                        <div className={styles.mistakes}>
                            <div className={styles.wrapper}>
                                <div className={styles.number}>{`${numOfAlowedMistakes} / ${numOfAlowedMistakes}`}</div>
                                <div className={styles.text}>{translate('MistakesMade')}</div>
                            </div>
                        </div>
                    </div>
                    <div className={styles['attempts-wrapper']}>
                        <div className={styles.attempts}>
                            <div className={styles.wrapper}>
                                <div className={styles.number}>{numberOfAttempts - 1}</div>
                                <div className={styles.text}>{translate('AttemptsLeft')}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles['bottom-wrapper']}>
                    <div>
                        <Button
                            id="reakte-test-button"
                            type={'bigGradient'}
                            onClick={isRetakeEnabled ? onRetake : onGoHome}
                            text={isRetakeEnabled ? translate('ReTakeTest') : translate('GoHome')}
                            lowerCase
                            className={styles.button}
                        />
                    </div>

                    {isRetakeEnabled && (
                        <div className={styles.home} onClick={() => onGoHome()}>
                            {translate('GoHome')}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

interface QuizPopupProps {
    numOfAlowedMistakes: number;
    numberOfAttempts: number;
    isRetakeEnabled: boolean;
    setIsPopupOpen: Function;
    onRetake: Function;
}

export default QuizPopup;
